import React, { Component } from 'react';

//styles
import './App.scss';
import '../../static/fonts/opensanshebrew/stylesheet.css';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import mapMobile from '../../static/images/mobile/map.png';
import map from '../../static/images/map.png';
import {isMobile, isIos} from '../../static/helper';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="vote-image"></div>
        <div className="desc-container">
          <h2 className="title">#קולהמדינה</h2>
          <h3 className="sub-title">היישר מהמקרר</h3>
          <p className="desc">
            תוצאות האמת לבחירות הכלליות של מדינת קוקה-קולה
              </p>
        </div>
        <img className="map" src={isMobile() || isIos() ? mapMobile : map}/>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js